import { createSlice } from "@reduxjs/toolkit";
import {
  CLIENT_MEMBER_DETAILS,
  CLIENT_MEMBER_LIST_STATE,
  CLIENT_MEMBER_STATS,
} from "../../state";

const initialState = {
  ...CLIENT_MEMBER_LIST_STATE,
  ...CLIENT_MEMBER_STATS,
  ...CLIENT_MEMBER_DETAILS,
};

const clientMemberSlice = createSlice({
  name: "CLIENT_MEMBER_SLICE",
  initialState,
  reducers: {
    // LIST
    startClientMemberList: (state) => {
      state.clientMemberListLoading = true;
      state.clientMemberListError = null;
    },
    successClientMemberList: (state, action) => {
      state.clientMemberListLoading = false;
      state.clientMemberList = action.payload.list;
      state.total = action.payload.total;
      console.log("Reducer data received:", action.payload);
    },
    errorClientMemberList: (state, action) => {
      state.clientMemberListLoading = false;
      state.clientMemberListError = action.payload;
    },

    // STATS
    startClientMemberStats: (state) => {
      state.clientMemberStatsLoading = true;
      state.clientMemberStatsError = null;
    },
    successClientMemberStats: (state, action) => {
      state.clientMemberStatsLoading = false;
      state.clientMemberStats = action.payload;
      console.log("Stats data received:", action.payload);
    },
    errorClientMemberStats: (state, action) => {
      state.clientMemberStatsLoading = false;
      state.clientMemberStatsError = action.payload;
    },

    // DETAILS
    startClientMemberDetails: (state) => {
      state.clientMemberDetailsLoading = true;
      state.clientMemberDetailsError = null;
    },
    successClientMemberDetails: (state, action) => {
      state.clientMemberDetailsLoading = false;
      state.clientMemberDetails = action.payload;
      console.log("Details data received:", action.payload);
    },
    errorClientMemberDetails: (state, action) => {
      state.clientMemberDetailsLoading = false;
      state.clientMemberDetailsError = action.payload;
    },
  },
});

export const {
  startClientMemberList,
  successClientMemberList,
  errorClientMemberList,
  startClientMemberStats,
  successClientMemberStats,
  errorClientMemberStats,
  startClientMemberDetails,
  successClientMemberDetails,
  errorClientMemberDetails,
} = clientMemberSlice.actions;

export default clientMemberSlice.reducer;
